import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from "./Container.styles";
export var PlainContentModuleContainer = function(param) {
    var children = param.children, rules = param.rules;
    var ref = rules || {}, _backgroundStyle = ref.backgroundStyle, backgroundStyle = _backgroundStyle === void 0 ? "default" : _backgroundStyle, _layoutFlow = ref.layoutFlow, layoutFlow = _layoutFlow === void 0 ? "right" : _layoutFlow, verticalSpacing = ref.verticalSpacing;
    var isLarge = (verticalSpacing || {}).isLarge;
    return /*#__PURE__*/ _jsx(Container, {
        isLarge: isLarge,
        layoutFlow: layoutFlow,
        backgroundStyle: backgroundStyle,
        children: children
    });
};
